import ApplyStepButtons from 'components/ApplyStepButtons'
import ApplyStepIcon from 'components/ApplyStepIcon'

import s from './ApplyOpenCallTimes.module.css'
import { useAtom } from 'jotai'
import { sitesAtom } from '../../../lib/atoms'
import classNames from 'classnames'

//TODO: setup proptypes
function ApplyOpenCallTimes({
                              slug,
                              times,
                              timeNotes,
                              openCallAddress,
                              back,
                              next,
                            }) {
  const [sites] = useAtom(sitesAtom)

  const site = sites.find((s) => s.path.replace(/\//g, '') === slug)

  return (
    <div className={s.container}>
      <h1 className={s.title}>
        {site.name}
        <br />
        Open Call Times
      </h1>
      <ul className={s.times}>
        {times.map((t) => (
          <li key={`${t.day}_${t.time}`} className={s.timeRow}>
            <span className={classNames([s.timeDay, !t.day ? s.empty : ''])}>{t.day}</span>
            <span className={s.timeTime}>{t.time}</span>
          </li>
        ))}
      </ul>
      <div className={s.text} dangerouslySetInnerHTML={{ __html: timeNotes }} />
      <h2 className={s.subTitle}>Getting here</h2>
      <div
        className={s.text}
        dangerouslySetInnerHTML={{ __html: openCallAddress }}
      />
      <ApplyStepButtons back={back} next={next} />
      <ApplyStepIcon step='location' />
    </div>
  )
}

export default ApplyOpenCallTimes
